import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TIER_LABEL } from "../lib/api";
import { Phone, Building2, Mail, ExternalLink } from "lucide-react";
import LeadRequestForm from "./LeadRequestForm";

export default function AttorneyCard({ attorney, county, state }) {
    const [showLead, setShowLead] = useState(false);
    const hasLeads = !!attorney.has_leads;
    return (
        <div className="ll-card ll-card-hover" data-testid={`attorney-card-${attorney.id}`}>
            <div className="flex items-start justify-between gap-3 mb-3">
                <Link
                    to={`/attorney/${attorney.id}`}
                    className="flex items-start gap-3 group min-w-0 flex-1"
                    data-testid={`attorney-card-link-${attorney.id}`}>
                    {attorney.photo_url ? (
                        <img src={attorney.photo_url} alt={attorney.name} className="w-14 h-14 rounded-xl object-cover border border-border flex-shrink-0" />
                    ) : (
                        <div className="w-14 h-14 rounded-xl bg-muted flex items-center justify-center border border-border flex-shrink-0 font-serif text-lg text-muted-foreground">
                            {attorney.name?.[0] || "?"}
                        </div>
                    )}
                    <div className="min-w-0">
                        <h4 className="font-serif text-lg font-semibold tracking-tight group-hover:text-primary inline-flex items-center gap-1.5">
                            {attorney.name}
                            <ExternalLink className="h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </h4>
                        <div className="text-xs text-muted-foreground flex items-center gap-1.5 mt-0.5">
                            <Building2 className="h-3.5 w-3.5" />
                            {attorney.firm_name || "Independent practice"}
                        </div>
                    </div>
                </Link>
                <span className={`ll-pill tier-${attorney.tier}`} data-testid={`tier-badge-${attorney.tier}`} title="Profile tier — set by the attorney's plan, not a client rating">
                    {TIER_LABEL[attorney.tier] || attorney.tier}
                </span>
            </div>
            {attorney.bio && <p className="text-sm text-muted-foreground leading-relaxed mb-4">{attorney.bio}</p>}
            <div className="flex flex-wrap items-center gap-3">
                {attorney.phone && (
                    <a href={`tel:${attorney.phone.replace(/\D/g, "")}`}
                       className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
                       data-testid={`attorney-phone-${attorney.id}`}>
                        <Phone className="h-4 w-4" />
                        {attorney.phone}
                    </a>
                )}
                {hasLeads && !showLead && (
                    <button onClick={() => setShowLead(true)}
                            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
                            data-testid={`attorney-request-contact-${attorney.id}`}>
                        <Mail className="h-4 w-4" />
                        Request contact
                    </button>
                )}
                <Link
                    to={`/attorney/${attorney.id}`}
                    className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-primary ml-auto"
                    data-testid={`attorney-view-profile-${attorney.id}`}>
                    View profile <ExternalLink className="h-3 w-3" />
                </Link>
            </div>
            {hasLeads && showLead && (
                <LeadRequestForm attorney={attorney} county={county} state={state} onClose={() => setShowLead(false)} />
            )}
        </div>
    );
}
